import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const DEFAULTS = { services_label: "Services" };
const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {}, update: async () => {} });

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch {
      setSettings(DEFAULTS);
    }
  }, []);

  useEffect(() => {
    if (user) refresh();
  }, [user, refresh]);

  const update = async (payload) => {
    const { data } = await api.patch("/settings", payload);
    setSettings({ ...DEFAULTS, ...data });
    return data;
  };

  const value = useMemo(() => ({ settings, refresh, update }), [settings, refresh]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}

export function useServicesLabel() {
  const { settings } = useSettings();
  const plural = settings.services_label || "Services";
  // Heuristic: drop trailing 's' for singular form (handles Services → Service, Labor Fees → Labor Fee)
  const singular = plural.endsWith("s") ? plural.slice(0, -1) : plural;
  return { plural, singular, pluralLower: plural.toLowerCase(), singularLower: singular.toLowerCase() };
}
